import axiosInstance from "./service-instance";
import { CONTENT_TYPES } from "constants";

export default {
    addCaseNote: (data, stage_id) =>
        axiosInstance.post(
            "/case/notes/add/",
            {
                ...data,
                stage_id
            },
            {
                headers: {
                    "Content-Type": CONTENT_TYPES.APPLICATION_JSON
                }
            }
        ),
    fetchCaseNotes: case_id =>
        axiosInstance.get(`/case/${case_id}/notes/`, {
            params: {
                paginate: false
            }
        }),
    deleteCaseNote: (data) =>
        axiosInstance.post("/case/note/delete/", data),
    
    retrieveCaseNote: (data) =>
        axiosInstance.post("/case/note/retrieve/", data),
};
